import { Flex, Text } from '@chakra-ui/react';
import { FormFeedback, Input, Radio, TextArea } from '@morressier/alembic';
import { RegisterOptions, useFormContext } from 'react-hook-form';
import { FieldLabel } from 'src/components/Field';
import {
  GeneralInfoEditFormValues,
  GeneralInfoEditableFieldConfig
} from './generalInfoConfig';

const GeneralInfoFormField = ({
  fieldConfig,
  registerOptions
}: {
  fieldConfig: GeneralInfoEditableFieldConfig;
  registerOptions: RegisterOptions<GeneralInfoEditFormValues, 'value'>;
}) => {
  const {
    register,
    watch,
    formState: { errors }
  } = useFormContext<GeneralInfoEditFormValues>();
  const currentValue = watch('value') ?? '';
  const errorMessage = errors.value?.message;

  if (fieldConfig.inputType === 'radio') {
    return (
      <Flex flexDirection="column" flex="1" gap={2}>
        <FieldLabel
          label={fieldConfig.label}
          subText={fieldConfig.subText ?? ''}
          isRequired={fieldConfig.isRequired}
        />
        {fieldConfig.options?.map(option => (
          <Radio
            key={option.value}
            {...register('value', registerOptions)}
            value={option.value}
            ariaLabel={option.value}
            id={`${fieldConfig.key}-${option.value}`}
          >
            <Text textStyle="headingItem">{option.label}</Text>
            <Text>{option.subText}</Text>
          </Radio>
        ))}
        {errorMessage ? (
          <FormFeedback variant="error">{errorMessage}</FormFeedback>
        ) : null}
      </Flex>
    );
  }

  return (
    <Flex flexDirection="column" flex="1" gap={2}>
      <FieldLabel
        label={fieldConfig.label}
        subText={fieldConfig.subText ?? ''}
        isRequired={fieldConfig.isRequired}
      />
      {fieldConfig.inputType === 'textarea' ? (
        <TextArea
          value={watch('value')}
          {...register('value', registerOptions)}
          placeholder={fieldConfig.placeholder}
          isInvalid={Boolean(errorMessage)}
          maxLength={fieldConfig.maxLength}
          rows={5}
        />
      ) : (
        <Input
          {...register('value', registerOptions)}
          placeholder={fieldConfig.placeholder}
          isInvalid={Boolean(errorMessage)}
          maxLength={fieldConfig.maxLength}
        />
      )}
      {errorMessage ? (
        <FormFeedback variant="error">{errorMessage}</FormFeedback>
      ) : null}
      {fieldConfig.maxLength ? (
        <Text textStyle="textContext" alignSelf="flex-end">
          {currentValue.length}/{fieldConfig.maxLength}
        </Text>
      ) : null}
    </Flex>
  );
};

export default GeneralInfoFormField;
